import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "app-lotus-bloom",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg class="lotus-bloom" viewBox="0 0 200 220" aria-hidden="true">
      <g class="lb-rings">
        <ellipse class="lb-ring lb-ring-a" cx="100" cy="150" rx="30" ry="8" />
        <ellipse class="lb-ring lb-ring-b" cx="100" cy="150" rx="30" ry="8" />
        <ellipse class="lb-ring lb-ring-c" cx="100" cy="150" rx="30" ry="8" />
      </g>

      <g class="lb-flower">
        <g fill="currentColor">
          <path
            class="lb-petal"
            transform="rotate(0 100 150)"
            d="M100,150 C87,127 89,103 100,88 C111,103 113,127 100,150 Z"
            opacity="0.92"
          />
          <path
            class="lb-petal"
            transform="rotate(45 100 150)"
            d="M100,150 C87,127 89,103 100,88 C111,103 113,127 100,150 Z"
            opacity="0.92"
          />
          <path
            class="lb-petal"
            transform="rotate(90 100 150)"
            d="M100,150 C87,127 89,103 100,88 C111,103 113,127 100,150 Z"
            opacity="0.92"
          />
          <path
            class="lb-petal"
            transform="rotate(135 100 150)"
            d="M100,150 C87,127 89,103 100,88 C111,103 113,127 100,150 Z"
            opacity="0.92"
          />
          <path
            class="lb-petal"
            transform="rotate(180 100 150)"
            d="M100,150 C87,127 89,103 100,88 C111,103 113,127 100,150 Z"
            opacity="0.92"
          />
          <path
            class="lb-petal"
            transform="rotate(225 100 150)"
            d="M100,150 C87,127 89,103 100,88 C111,103 113,127 100,150 Z"
            opacity="0.92"
          />
          <path
            class="lb-petal"
            transform="rotate(270 100 150)"
            d="M100,150 C87,127 89,103 100,88 C111,103 113,127 100,150 Z"
            opacity="0.92"
          />
          <path
            class="lb-petal"
            transform="rotate(315 100 150)"
            d="M100,150 C87,127 89,103 100,88 C111,103 113,127 100,150 Z"
            opacity="0.92"
          />
        </g>
        <circle cx="100" cy="150" r="13" fill="currentColor" opacity="0.55" />
        <g fill="var(--color-paper)" opacity="0.9">
          <circle cx="94" cy="146" r="1.6" />
          <circle cx="106" cy="146" r="1.6" />
          <circle cx="100" cy="152" r="1.6" />
          <circle cx="93" cy="154" r="1.6" />
          <circle cx="107" cy="154" r="1.6" />
        </g>
      </g>

      <g fill="currentColor">
        <g transform="translate(55,170) scale(0.6)">
          <path
            class="lb-drift lb-drift-a"
            d="M0,0 C-5,-12 -5,-26 0,-38 C5,-26 5,-12 0,0 Z"
            opacity="0.5"
          />
        </g>
        <g transform="translate(145,170) scale(0.45)">
          <path
            class="lb-drift lb-drift-b"
            d="M0,0 C-5,-12 -5,-26 0,-38 C5,-26 5,-12 0,0 Z"
            opacity="0.5"
          />
        </g>
        <g transform="translate(100,170) scale(0.55)">
          <path
            class="lb-drift lb-drift-c"
            d="M0,0 C-5,-12 -5,-26 0,-38 C5,-26 5,-12 0,0 Z"
            opacity="0.5"
          />
        </g>
      </g>
    </svg>
  `,
  styles: [
    `
      :host {
        display: block;
        color: var(--color-saffron);
        width: 220px;
      }
      .lotus-bloom {
        display: block;
        width: 100%;
        height: auto;
        overflow: visible;
      }
      .lb-flower {
        transform-origin: 100px 150px;
        animation: lb-breathe 5.5s ease-in-out infinite;
      }
      @keyframes lb-breathe {
        0%,
        100% {
          transform: scale(1);
        }
        50% {
          transform: scale(1.045);
        }
      }
      .lb-ring {
        fill: none;
        stroke: currentColor;
        stroke-width: 1;
        transform-origin: 100px 150px;
        animation: lb-ripple 4.5s ease-out infinite;
        opacity: 0;
      }
      .lb-ring-b {
        animation-delay: -1.5s;
      }
      .lb-ring-c {
        animation-delay: -3s;
      }
      @keyframes lb-ripple {
        0% {
          transform: scale(0.3);
          opacity: 0.5;
        }
        70% {
          opacity: 0;
        }
        100% {
          transform: scale(1.8);
          opacity: 0;
        }
      }
      .lb-drift {
        transform-box: fill-box;
        animation-timing-function: ease-in-out;
        animation-iteration-count: infinite;
      }
      .lb-drift-a {
        animation-name: lb-drift-up;
        animation-duration: 9s;
        animation-delay: 0s;
      }
      .lb-drift-b {
        animation-name: lb-drift-up;
        animation-duration: 11s;
        animation-delay: -3s;
      }
      .lb-drift-c {
        animation-name: lb-drift-up;
        animation-duration: 10s;
        animation-delay: -6.5s;
      }
      @keyframes lb-drift-up {
        0% {
          transform: translateY(0) rotate(0deg);
          opacity: 0;
        }
        15% {
          opacity: 0.5;
        }
        85% {
          opacity: 0.15;
        }
        100% {
          transform: translateY(-95px) rotate(15deg);
          opacity: 0;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        .lb-flower,
        .lb-ring,
        .lb-drift {
          animation: none;
        }
        .lb-ring {
          opacity: 0.3;
        }
      }
    `,
  ],
})
export class LotusBloom {}
